<template>
  <Layout>
    <PageHeader :title="title" :items="items" /> 
      <div class="hori-timeline mb-3">
       <hr>
        <div class="d-flex justify-content-between align-items-center mb-2 px-3">
          <h4 class="my-auto">{{ $t('twitter.top-trend') }}</h4>
          <button class="btn btn-primary px-2 py-1" @click="getTrends24">
            <div class="d-flex align-items-center">
              <i class="bx bx-rotate-right bx-xs mr-1" :class="trends24.list != 0 ? '' : 'bx-spin'"></i>
              <small>{{ $t('twitter.reload') }}</small> 
            </div>
          </button>
          <!-- <b-button size="xs" variant="secondary">
            <i class=" bx bx-rotate-right bx-sm"></i>
          </b-button> -->
        </div>
        <carousel
        v-if="trends24.list != 0"
          class="events navs-carousel mt-4"
          id="timeline-carousel"
          :perPageCustom="[[480, 3], [768, 5]]"
          :paginationPosition="'bottom-overlay'"
          :autoplay="true"
          :autoplayTimeout="10000"
          :loop="true"
          :speed="1500"
        >
          <slide v-for="(alltrends, index) in trends24.list" :key="index" style="margin-bottom:30px">
            <div class="item event-list">
              <div class="table-responsive px-3">
                <table class="card table table-hover mb-0 h-100">
                  <thead>
                    <tr>
                        <th v-if="index == 0">
                          <div v-if="trends24.last_update.minutes == 0">
                            {{trends24.last_update.seconds}} {{ $t('twitter.second-ago.text') }}
                          </div>
                          <div v-else>
                            {{trends24.last_update.minutes}}  {{ $t('twitter.minutes-ago.text') }}
                          </div>
                        </th>
                        <th v-else>{{index}}  {{ $t('twitter.hour-ago.text') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(trend, index) in JSON.parse(alltrends).splice(0,10)" :key="index" class="text-left" :class="activequery == trend.query ? 'bg-light' : ''" :ref="trend.query" @mouseover="onHover(trend.query)" @mouseleave="onLeave()">
                      <td scope="row" width="4%" class="text-secondary">{{index+1}}</td>
                      <td>
                        <a :href="trend.url" target="_blank">{{trend.name}}</a> 
                        <br>
                        <small v-if="trend.tweet_volume" class="text-secondary">{{formatNumber(trend.tweet_volume, 1)}} tweets</small>
                        <small v-else class="text-secondary">--</small>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </slide>
        </carousel>
        <div v-else class="text-center mt-4">
          <i class="bx bx-loader-alt bx-spin bx-lg"></i>
        </div>
        
      </div>
    
    <div class="row mt-3 mb-5 p-4">
        <div class="card w-100">
            <div class="card-body">
                <div class="col-12">
                    <h4>Analisa Wave</h4>
                </div>
                <div class="col-12">
                    *cooming soon
                </div>
            </div>
        </div>
    </div>

  </Layout>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import TwintService from "@/helpers/twint.service.js";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import store from '@/state/store';
import moment from 'moment';
import Particle from "./particle.vue";
import SocmedService from "@/helpers/socmed.service";
import Swal from "sweetalert2";
// import { tableData } from "./dataAdvancedtable";

export default {
  page: {
    title: "Tools Twitter",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Particle, Carousel, Slide },
  data() {
    return {
      trend_jakarta:[],
      trend_bandung:[],
      trend_indonesia:[],
      trend_world:[],
      tableData:[],
      total_results:"",
      selected: [],
      selectAll: false,
      search:false,
      loadingInfo:false,
      searchKey: '',
      title: "Twitter",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Twitter",
          active: true
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "no",  class: 'text-center', thStyle: { width: "2%" }, label:'No'},
        { key: "bulk",  thStyle: { width: "2%" }, label:'#'},
        { key: "id_twitter", thClass: 'd-none', tdClass: 'd-none'},
        { key: "user_id", thClass: 'd-none', tdClass: 'd-none'},
        { key: "avatar", thClass: 'd-none', tdClass: 'd-none'},
        { key: "updated_at", thClass: 'd-none', tdClass: 'd-none'},
        { key: "name", thClass: 'd-none', tdClass: 'd-none'},
        { key: "account", sortable: true,  label: this.$t('twitter.table.account')},
        { key: "followers", sortable: true,  label: this.$t('twitter.table.followers') },
        { key: "following", sortable: true,  label: this.$t('twitter.table.following') },
        { key: "tweets", sortable: true,  label: this.$t('twitter.table.post') },
        { key: 'actions', class: 'text-center',  label: this.$t('twitter.table.action') }
      ],
      trends24: {
        list : [],
        last_update : '',
      },
      activequery: ''
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    }
  },
  methods:{
    searchTwitter(){
        this.search = true;
    },
    select() {
        this.selected = [];
        if (!this.selectAll) {
            for (let i in this.tableData) {
                this.selected.push(this.tableData[i].id_twitter);
            }
        }
    },
    getTrends24() {
      this.trends24.list = []
        SocmedService.getTrends()
        .then((response) => {
          Object.entries(response.data.data).forEach(([k,v]) => {
            if (k != 'id_trend' && k != 'created_at' && k != 'updated_at' && k != 'last_update') {
              this.trends24.list.push(v);
            }
          });
          this.diffTime(response.data.data.last_update)
        })
        .catch((err) => {
            this.trends24.list
        });
    },
    // getTrendJakarta() {
    //     const data = {
    //         "woied_lokasi": 1047378,
    //       };
    //         TwintService.getTrend(data)
    //         .then((response) => {
    //             this.trend_jakarta.push(response.data.output)
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //         });
    //     },
    //     getTrendBandung() {
    //     const data = {
    //         "woied_lokasi": 1047180,
    //       };
    //         TwintService.getTrend(data)
    //         .then((response) => {
    //             this.trend_bandung.push(response.data.output)
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //         });
    //     },
    //     getTrendIndonesia() {
    //     const data = {
    //         "woied_lokasi": 23424846,
    //     };
    //         TwintService.getTrend(data)
    //         .then((response) => {
    //             this.trend_indonesia.push(response.data.output)
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //         });
    //     },
    //   getTrendWorld() {
    //       const data = {
    //           "woied_lokasi": 1,
    //       };
    //           TwintService.getTrend(data)
    //           .then((response) => {
    //               this.trend_world.push(response.data.output)
    //           })
    //           .catch((err) => {
    //               console.log(err);
    //           });
    //      },
      listTwitter(){
        this.loadingInfo = true;
        SocmedService.getAllTwitter()
        .then(response => {
                  this.tableData = []
                  this.total_results = response.data.data.length
                   response.data.data.forEach((val, index) => {
                      const data = {    
                      "no" : index+1,
                      "id_twitter" : val.id_twitter,
                      "user_id" : val.user_id,
                      "account" : val.account,
                      "name" : val.name,
                      "verified" : val.is_verified,
                      "avatar" : val.avatar,
                      "followers" : val.followers,
                      "following" : val.following,
                      "tweets" : val.tweets,
                      "join_at" : val.join_at,
                      "created_at" : this.formatDate(val.created_at),
                      "updated_at" : this.formatDate(val.updated_at),
                      }
                      this.tableData.push(data);
                      this.loadingInfo = false;
                  });
              })
              .catch(err => {
                  console.log(err);
                  this.loadingInfo = false;
          });
      },
      deleteTwitter(id){
            Swal.fire({
                title: this.$t('button.delete.modal.confirmText[0]'),
                text: this.$t('button.delete.modal.confirmText[1]'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                cancelButtonText: this.$t('button.cancel.text'),
                confirmButtonText: this.$t('button.delete.text')
            }).then((result) => {
                if (result.isConfirmed) {
                    SocmedService.deleteTwitter(id)
                    .then( response => {
                        this.listTwitter();
                        Swal.fire({
                            position: "top-end",
                            icon: "success",
                            title: response.data.message,
                            showConfirmButton: false,
                            timer: 1500
                        });
                    })
                    .catch( err => {
                        console.log(err);
                    });
                }
            });
      },
      bulkAction(){
            Swal.fire({
                title: this.$t('button.delete.modal.confirmText[0]'),
                text: this.$t('button.delete.modal.confirmText[1]'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                cancelButtonText: this.$t('button.cancel.text'),
                confirmButtonText: this.$t('button.delete.text')
            }).then((result) => {
                if (result.isConfirmed) {
                  var data = this.selected;
                    SocmedService.deleteBulkTwitter(data)
                    .then( response => {
                        this.selected = [];
                        this.listTwitter();
                        Swal.fire({
                            position: "top-end",
                            icon: "success",
                            title: this.$t('alert.alert-delete-twitter'),
                            showConfirmButton: false,
                            timer: 1500
                        });
                    })
                    .catch( err => {
                        console.log(err);
                    });
                }
            });
      },
      formatDate(value){
          return moment(value).format("dddd, YYYY-MM-DD hh:mm");
      },
      formatNumber(count, decimals = 2){
        const COUNT_ABBRS = [ '', 'K', 'M', 'B', 'T'];
        const i     = 0 === count ? count : Math.floor(Math.log(count) / Math.log(1000));
        let result  = parseFloat((count / Math.pow(1000, i)).toFixed(decimals));
        result += `${COUNT_ABBRS[i]}`; 
        return result;

      },
      diffTime(value){
        const currTime = moment().format("HH:mm:ss")
        const lastTime = moment(value).format("HH:mm:ss")
        const startTime = moment.duration(currTime, "HH:mm:ss")
        const endTime  = moment.duration(lastTime, "HH:mm:ss")
        const diff = startTime.subtract(endTime)
        this.trends24.last_update = diff._data;
      },
      onHover(id){
        this.activequery = id;
      },
      onLeave(){
        this.activequery = ''
      }
  },
  mounted(){
    console.log('ref ==> ',this.$refs);
    this.totalRows = this.items.length;
    this.listTwitter();
    this.getTrends24();
    // this.getTrendIndonesia();
    // this.getTrendWorld();
    // this.getTrendJakarta();
    // this.getTrendBandung();
  }
};
</script>

<style scoped>
/* .card{
  border: 2px solid #f1f1f1;
} */
/* .my-custom-scrollbar {
position: relative;
height: 700px;
overflow: auto;
}
.table-wrapper-scroll-y {
display: block;
} */
</style>